import Toast from './toast.element.js';

export default Toast;

Toast.define('wje-toast', Toast);
